import { Component, Input, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { PedidoConsultaOutput } from 'src/app/@shared/models/consulta-detalhe';

@Component({
  selector: 'app-bloco-detalhes',
  templateUrl: './bloco-detalhes.component.html',
  styleUrls: ['./bloco-detalhes.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class BlocoDetalhesComponent implements OnInit, OnDestroy {
  @Input('Pedido') pedido: any;
  @Input('TabIndex') tabIndex = 0;

  constructor() { }

  ngOnInit() {

  }

  ngOnDestroy() {
    this.tabIndex = 0;
  }

  changeEvent(event) {
    this.tabIndex = event.index;
  }

  getRatLink(pedidoId) {
    return `https://portal-vesta.sequoialog.com.br/tms/frmCadastroRat.aspx?nrt=${pedidoId}`;
  }

  imprimir() {
    window.print();
  }
}
